import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=34be16e4&"
import script from "./GroupList.vue?vue&type=script&lang=js&"
export * from "./GroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports